//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
SPLM.CAM.CamPathToolpathEventType = Object.freeze({
    "Motion" : "Motion", "Ude" : "Ude", "System" : "System", "LevelMarker" : "LevelMarker", "Marker" : "Marker"});

SPLM.CAM.CamPathMotionType = Object.freeze({
    "Undefined" : "Undefined", "Rapid" : "Rapid", "Engage" : "Engage", "Cut" : "Cut", "Retract" : "Retract", "FirstCut" : "FirstCut", "Approach" : "Approach", "Stepover" : "Stepover", "Departure" : "Departure", "Return" : "Return", "Traversal" : "Traversal", "SideCut" : "SideCut", "From" : "From", "Gohome" : "Gohome", "Cycle" : "Cycle", "InternalLift" : "InternalLift"});

SPLM.CAM.CamPathMotionShapeType = Object.freeze({
    "Undefined" : "Undefined", "Linear" : "Linear", "Circular" : "Circular", "Helical" : "Helical", "Nurbs" : "Nurbs"});

SPLM.CAM.CamPathContactMotionShapeType = Object.freeze({
    "Undefined" : "Undefined", "Linear" : "Linear", "Circular" : "Circular"});

SPLM.CAM.CamPathDir = Object.freeze({
    "Clockwise" : "Clockwise", "Counterclockwise" : "Counterclockwise"});

SPLM.CAM.CamPathFeedUnitType = Object.freeze({
    "PerMinute" : "PerMinute", "PerRevolution" : "PerRevolution", "None" : "None"});

SPLM.CAM.CamPathToolAxisType = Object.freeze({
    "Three" : "Three", "Five" : "Five"});

SPLM.CAM.CamPathToolpathEventLocation = Object.freeze({
    "Before" : "Before", "After" : "After", "End" : "End"});

SPLM.CAM.CamPathContactType = Object.freeze({
    "None" : "None", "TwoDimensional" : "TwoDimensional", "ThreeDimensional" : "ThreeDimensional"});

export default SPLM;